import isMac from '../isMac';

const platformShortcut = (shortcut: string) => {
    // Adding this in runtime so we can mock it
    const tokens: Record<string, string> = {
        meta: isMac() ? '⌘' : 'Ctrl+',
        enter: '⏎',
    };

    return shortcut.replaceAll(/{(\w+?)}/gi, (original, token) => tokens[token] ?? original);
};

export default platformShortcut;
